import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceHappy20Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFaceHappy20Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18M7.075 9.1a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25m6.975-1.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m-8.31 3.322a.75.75 0 0 1 .961.437l.003.006.02.048a3 3 0 0 0 .635.877c.486.477 1.303.985 2.641.985s2.155-.508 2.641-.985c.25-.245.42-.49.524-.67a3 3 0 0 0 .131-.255l.003-.006a.75.75 0 0 1 1.404.527L14 12l.703.261v.001l-.001.002-.002.005-.004.011a2 2 0 0 1-.06.138q-.059.13-.176.336c-.159.27-.406.626-.768.981-.736.723-1.92 1.415-3.692 1.415s-2.956-.692-3.692-1.415a4.8 4.8 0 0 1-.767-.98 4 4 0 0 1-.237-.475l-.004-.01-.002-.005v-.002h-.001c0-.001 0-.002.703-.262l-.703.26a.75.75 0 0 1 .443-.963"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFaceHappy20Filled);
